<template >
    <select id="select2ajax-template" style = "width: 100%" > </select> 
</template>

<script>
var VUE_APP_API_URL = process.env.VUE_APP_API_URL;
export default {
    name: 'Select2Ajax',
    props: ['options', 'value'],
    template: '#select2ajax-template',
    mounted: function() {
        var vm = this;
        $(this.$el)
            // init select2
            .select2({
                ajax: {
                    url: VUE_APP_API_URL + 'user/all-users-search',
                    // Read token fresh on each request (module-scope closure was capturing empty token).
                    beforeSend: function (xhr) {
                        const t = window.localStorage.getItem("token") || "";
                        if (t) xhr.setRequestHeader("Authorization", "Bearer " + t);
                    },
                    dataType: 'json',
                    delay: 500,
                    cache: true,
                    data: function(params) {
                        var query = {
                            search: params.term,
                            _type: 'query',
                            q: params.term
                        };
                        // Query parameters will be ?search=[search]&_type=query&q=q
                        return query;
                    },
                    // Additional AJAX parameters go here; see the end of this chapter for the full code of this example
                    processResults: function(data) {
                        // Tranforms the top-level key of the response object from 'items' to 'results'
                        var result_data = $.map(data.Data, function(obj) {
                            obj.id = obj._id;
                            obj.text = obj.first_name + ' ' + obj.last_name + ' (' + obj.email + ')';
                            return obj;
                        });
                        return {
                            results: result_data
                        };
                    }
                },
                placeholder: 'Search and Select Users'
            })
            .val(this.value)
            .trigger('change')
            // emit event on change.
            .on('change', async function() {
                vm.$emit('input', this.value); 
				
				vm.loading = true;
				var event_id = vm.$route.query.event_id;
                var skill_level = vm.$attrs.skill_level;
                var gender = vm.$attrs.gender;
                var team = vm.$attrs.team;
                if(team != "" && team < 1) {
                    vm.$apiService.notify("Team count Should be 1 or more.")
                    await new Promise(r => setTimeout(r, 1000));
                    window.location.reload();
                    return;
                }
                if (vm.$attrs.event_type == "Tournament" && vm.$attrs.skill_level_optional && skill_level == "") {
                    vm.$apiService.notify("Please Select Skill level.")
                    await new Promise(r => setTimeout(r, 1000));
                    window.location.reload();
                    return;
                }
                if (vm.$attrs.event_type == "Tournament" && vm.$attrs.tournament_type != "Open" && gender == "") {
                    vm.$apiService.notify("Please Select Gender.")
                    await new Promise(r => setTimeout(r, 1000));
                    window.location.reload();
                    return;
                }

			    var postdata = {
					event_id: event_id,
					user_id: this.value,
                    skill_level: skill_level,
                    gender: gender,
                    team: team
				}; 
                console.log(postdata)
				const book = await vm.$apiService.postCall(
					"booking/add-booking-manually",
					postdata
				); 
				
				debugger; 
				if(book.apidata.Message !== "Success"){
					vm.$apiService.notify(book.apidata.Message);
                    await new Promise(r => setTimeout(r, 2000));
					window.location.reload();
				}else{
					vm.$apiService.notify("Booking is successfully created.");
					await new Promise(r => setTimeout(r, 1000));
					window.location.reload();
				}  
            });
    },
    watch: {
        value: function(value) {
            // update value
            $(this.$el).val(value);			
        },
        options: function(options) {
            // update options
            $(this.$el)
                .empty()
                .select2({
                    data: options
                });
        }
    },
    destroyed: function() {
        $(this.$el)
            .off()
            .select2('destroy');
    }
}; 
</script>

<style >
.select2-container--default {
    border: 1px solid #d850d5;
}
.select2-container--default .select2-selection--single .select2-selection__rendered{
	color: white !important;
	font-weight : bold;
}
.select2-container--default .select2-selection--single .select2-selection__placeholder, .select2-results__option, .readable-label{
	color: white !important;
}
.select2-dropdown{
    border: 1px solid #c952e4;
    background: #27293d;
}
.select2-container--default .select2-search--dropdown .select2-search__field {
	color: white !important;
    border: 1px solid #d650d7;
    background: #27293d;
}
.select2-container--default .select2-selection--single, .select2-container--default .select2-selection--single .select2-selection__arrow
{
    border: unset;
    background: #27293d;
    height: 39px;
}
.select2-container--default .select2-selection--single .select2-selection__rendered{
    line-height: 40px;
}
</style>